import Footer from "../footer";
import Header from "../header";
import Card from "../card";
import IntroductionToOptionTrading from '../../images/cardpageimages/intermideate/introductiontooptiontrading.jpg'
import intermideateoptionstratigies from '../../images/cardpageimages/intermideate/intermideateoptionstratigies.jpg'
import masterclassimage from '../../images/cardpageimages/intermideate/mastetrclassimage.jpg'
import masteringofoptionchainimage from '../../images/cardpageimages/intermideate/masteringofoptonchain.jpg'

import fandotradingimage from '../../images/cardpageimages/intermideate/fandotrading.jpg'
import optiontradingtechnique from '../../images/cardpageimages/intermideate/optionstradingtechnique.jpg'

function IntermideateCourse(){
     return(<>
             <Header/>
             <div className="container-fluid py-4 bg-gray">
                <div className="container">
                <h2 className="text-center py-5">Have Look On Our Intermideate Courses</h2>
                    <div className="row d-md-flex d-block justify-content-evenly py-4">
                        {/* First Row - Always Visible */}
                        <div className="col-md-3 mt-0 mt-sm-3">
                            <Card
                                title="INTRODUCTION TO OPTIONS TRADING"
                                navigateurl="/introductionOptionTrading"
                                text="Discover the essentials of options trading for beginners."
                                image={IntroductionToOptionTrading}
                            />
                        </div>
                        <div className="col-md-3 mt-0 mt-sm-3">
                            <Card
                                title="INTERMEDIATE OPTIONS STRATEGIES"
                                navigateurl="/intermideateOptionStratigies"
                                text="Advanced techniques for effective options trading strategies"
                                image={intermideateoptionstratigies}
                            />
                        </div>
                        <div className="col-md-3 mt-0 mt-sm-3">
                            <Card
                                title="OPTIONS ANALYSIS MASTERCLASS"
                                navigateurl="/optionAnalysisMasterclass"
                                text="Comprehensive training for mastering options analysis techniques"
                                image={masterclassimage}
                            />
                        </div>
                        <div className="col-md-3 mt-0 mt-sm-3">
                            <Card
                                title="ADVANCED OPTIONS AND FUTURES TRADING"
                                navigateurl="/advancedOptionAndFutureTrade"
                                text="Expert strategies for advanced options and futures trading"
                                image={fandotradingimage}
                            />
                        </div>
                    </div>

                    {/* Second Row - All Cards Displayed */}
                    <div className="row d-block d-md-flex justify-content-evenly mt-3 mb-5 py-4">
                        <div className="col-md-3 mt-0 mt-sm-3">
                            <Card
                                title="INTERMEDIATE OPTIONS TRADING"
                                navigateurl="/intermideateOptionTrading"
                                text="Explore the art of visual coe design techniques."
                                image="Skills and strategies for successful intermediate options trading"
                            />
                        </div>
                        <div className="col-md-3 mt-0 mt-sm-3">
                            <Card
                                title="OPTIONS TRADING TECHNIQUES"
                                navigateurl="/optionsTradingTechnique"
                                text="Proven techniques for successful options trading strategies."
                                image={optiontradingtechnique}
                            />
                        </div>
                        <div className="col-md-3 mt-0 mt-sm-3">
                            <Card
                                title="MASTERING OPTIONS CHAIN"
                                navigateurl="/masteringOptionsChain"
                                text="Comprehensive guide to understanding options chain dynamics."
                                image={masteringofoptionchainimage}
                            />
                        </div>
                        <div className="col-md-3 mt-0 mt-sm-3">
                            <Card
                                title="HOW TO TRADE IN FUTURE & OPTIONS"
                                navigateurl="/howToTradeInFutureAndOptions"
                                text="Unlock the secrets of trading futures and options effortlessly"
                                image=""
                            />
                        </div>
                    </div>
                </div>
            </div>
             <Footer/>
     </>)
}
export default IntermideateCourse;
